import PropTypes from 'prop-types';
import React from 'react';

import { Button, DefaultSheet, SimpleAlert } from 'twyne-new.ui';

import CodeEditor from '@/components/CodeEditor';

const propTypes = {
  vendor: PropTypes.string
}

class ImportPlacement extends React.Component {
  state = {
    modal: false,
    value: ''
  }

  toggle = () => {
    this.setState({modal: !this.state.modal});
  }

  handleClickOpen = () => {
    this.setState({modal: true, value: ''});
  }

  componentDidUpdate() {
    this.state.error = null
  }

  handleOnSubmit = () => {
    if (this.state.value && this.state.value.trim() !== '') {
      try {
        this.props.onSubmit(this.state.value);
        this.setState({ modal: false });
      } catch (cause) {
        this.setState({ error: cause });
      }
    }
  }

  render () {
    const { vendor } = this.props;

    if ( vendor !== 'rexadz' ) {
      return null;
    }

    return (
      <div>
        <Button className='mt-4' variant='light' disabled={this.props.disabled} color="accent" onClick={this.handleClickOpen}>Import placement from {vendor}</Button>
        <DefaultSheet
          wrapperProps={{ open: this.state.modal, onOpenChange: open => !open && this.toggle() }}
          title="Use vendor placement"
          footer={<>
            <Button variant='ghost' onClick={this.toggle}>Cancel</Button>
            <Button color="accent" onClick={this.handleOnSubmit}>Import</Button>
          </>}
        >
          <div className='text-md twy-text-base-accent mb-2'>Paste here the provided script from your vendor and hit <b>Import</b></div>
          <CodeEditor
            value={this.state.value}
            onChange={value => this.setState({ value })}
            language="html"
            theme="textmate"
            className="h-[20vh] border-2 twy-border-base"
            editorProps={{ $blockScrolling: true }}
            wrapEnabled={true}
            focus={true}
          />
          {this.state.error && <SimpleAlert variant="danger" className='mt-3'>
            {this.state.error}
          </SimpleAlert>}
        </DefaultSheet>
      </div>
    );
  }
};

ImportPlacement.propTypes = propTypes;

export default ImportPlacement;